import deprecate from 'util-deprecate';
import { EmotionEventStrength } from '../../proto/packets.pb';
export var EmotionStrengthCode;
(function (EmotionStrengthCode) {
    EmotionStrengthCode["UNSPECIFIED"] = "UNSPECIFIED";
    EmotionStrengthCode["WEAK"] = "WEAK";
    EmotionStrengthCode["STRONG"] = "STRONG";
    EmotionStrengthCode["NORMAL"] = "NORMAL";
})(EmotionStrengthCode || (EmotionStrengthCode = {}));
var EmotionStrength = /** @class */ (function () {
    function EmotionStrength(strength) {
        this.code = strength;
    }
    EmotionStrength.prototype.isWeak = function () {
        return this.code === EmotionStrengthCode.WEAK;
    };
    EmotionStrength.prototype.isStrong = function () {
        return this.code === EmotionStrengthCode.STRONG;
    };
    EmotionStrength.fromProto = function (code) {
        switch (code) {
            case EmotionEventStrength.UNSPECIFIED:
                return EmotionStrengthCode.UNSPECIFIED;
            case EmotionEventStrength.WEAK:
                return EmotionStrengthCode.WEAK;
            case EmotionEventStrength.STRONG:
                return EmotionStrengthCode.STRONG;
            case EmotionEventStrength.NORMAL:
                return EmotionStrengthCode.NORMAL;
        }
    };
    return EmotionStrength;
}());
export { EmotionStrength };
EmotionStrength.prototype.isWeak = deprecate(EmotionStrength.prototype.isWeak, 'isWeak() is deprecated. Use code property instead.');
EmotionStrength.prototype.isStrong = deprecate(EmotionStrength.prototype.isStrong, 'isStrong() is deprecated. Use code property instead.');
